import { useSchemaOrg } from '@unhead/schema-org/react';

/**
 * @type {import('$types/components/partials/new-homes').NewHomesListingSchema}
 */

const NewHomesListingSchema = ({ page, url, items }) => {
    if (!page) {
        useSchemaOrg([], { tagPosition: 'head' });
        return null;
    }

    const schemas = [];

    // WebPage Schema for listing pages
    const webPageSchema = {
        '@type': 'WebPage',
        name: page.title,
        url: url,
    };

    // Add description if available
    if (page.searchDescription) {
        webPageSchema.description = page.searchDescription;
    } else if (page.listingText) {
        webPageSchema.description = page.listingText;
    }

    // Publisher (RealEstateAgent)
    webPageSchema.publisher = {
        '@type': 'RealEstateAgent',
        name: 'Beauchamp Estates',
        url: url?.split('/').slice(0, 3).join('/')
    };

    // Add breadcrumb if parent exists
    if (page.parent) {
        webPageSchema.breadcrumb = {
            '@type': 'BreadcrumbList',
            itemListElement: [
                {
                    '@type': 'ListItem',
                    position: 1,
                    name: 'Home',
                    item: url?.split('/').slice(0, 3).join('/')
                }
            ]
        };

        if (page.parent.title) {
            webPageSchema.breadcrumb.itemListElement.push({
                '@type': 'ListItem',
                position: 2,
                name: page.parent.title,
                item: page.parent.relativeUrl
                    ? `${url?.split('/').slice(0, 3).join('/')}${page.parent.relativeUrl}`
                    : url?.split('/').slice(0, 3).join('/')
            });
        }

        webPageSchema.breadcrumb.itemListElement.push({
            '@type': 'ListItem',
            position: webPageSchema.breadcrumb.itemListElement.length + 1,
            name: page.title,
            item: url
        });
    }

    // Main Entity: ItemList of new homes
    const itemList = {
        '@type': 'ItemList',
        numberOfItems: items?.total || items?.edges?.length || 0
    };

    // Add list items
    if (items?.edges && items.edges.length > 0) {
        itemList.itemListElement = items.edges
            .filter(edge => edge?.node)
            .map((edge, index) => {
                const property = edge.node;
                const propertyUrl = property.relativeUrl
                    ? `${url?.split('/').slice(0, 3).join('/')}${property.relativeUrl}`
                    : null;

                const listItem = {
                    '@type': 'ListItem',
                    position: index + 1,
                    item: {
                        '@type': 'Product',
                        name: property.displayAddress || property.title,
                        url: propertyUrl
                    }
                };

                // Add description if available
                if (property.listingText) {
                    listItem.item.description = property.listingText;
                }

                // Add image if available
                if (property.listingImage?.src) {
                    listItem.item.image = property.listingImage.src;
                }

                // Add price if available
                if (property.price) {
                    listItem.item.offers = {
                        '@type': 'Offer',
                        price: property.price,
                        priceCurrency: property.priceCurrency || 'GBP'
                    };
                }

                return listItem;
            });

        // Add geo coordinates from first property if available
        const firstPropertyWithCoords = items.edges.find(
            edge => edge?.node?.coordinates?.lat && edge?.node?.coordinates?.lng
        );

        if (firstPropertyWithCoords) {
            webPageSchema.geo = {
                '@type': 'GeoCoordinates',
                latitude: firstPropertyWithCoords.node.coordinates.lat,
                longitude: firstPropertyWithCoords.node.coordinates.lng
            };
        }
    }

    webPageSchema.mainEntity = itemList;

    schemas.push(webPageSchema);

    useSchemaOrg(schemas, { tagPosition: 'head' });

    return null;
};

export default NewHomesListingSchema;
